import {ResponseMessages} from '@/class/http';
import {Branch} from '@/store/branch/branch.types';
import {BaseDocument, BaseFilter} from '@/store/type';

export enum EventType {
  forTime = 'forTime',
  forMember = 'forMember'
}

export interface EventInitState {
  eventList: SeedEvent[],
  eventMember: SeedEvent[],
  eventMemberMain: SeedEvent[],
  eventTime: SeedEvent[],
  eventTotal: number
}

export class ResponseEvent extends ResponseMessages {
  public data!: BaseEvent[];
  public appCode!: number;

}

export interface BaseEvent {
  title: string;
  detail: string;
  imgRef: string;
  img: string;
  eventType: EventType;
  eventStatus: boolean;
  branchList: Branch[];
}

export interface SeedEvent extends BaseEvent, BaseDocument {
}

export interface DataGridEvent extends SeedEvent {
  key: number;
  branchId: string[];
  branchName: string[];
}

export interface FilterEvent extends SeedEvent, BaseFilter {

}

